import type { SupportedClient } from "@skills-marketplace/contracts/contract-2-plugin-store";
import styles from "./ClientBadge.module.css";

export const CLIENT_CONFIG: Record<SupportedClient, { label: string; color: string; bg: string; border: string }> = {
  "claude-chat":   { label: "Claude Chat",    color: "var(--color-info-text)", bg: "var(--color-info-bg)", border: "var(--color-info-border)" },
  "claude-cowork": { label: "Claude Cowork",  color: "var(--color-official-text)", bg: "var(--color-success-bg)", border: "var(--color-success-border)" },
  "claude-code":   { label: "Claude Code",    color: "var(--color-badge-plugin-text)", bg: "var(--color-badge-plugin-bg)", border: "var(--color-badge-plugin-border)" },
};

interface ClientBadgeProps {
  client: SupportedClient;
  onClick?: (client: SupportedClient) => void;
}

export default function ClientBadge({ client, onClick }: ClientBadgeProps) {
  const config = CLIENT_CONFIG[client];
  if (!config) {
    console.warn(`[ClientBadge] Unknown client value: "${client}". Entry may predate the client rename. Run the reprocess script to migrate.`);
  }
  const resolved = config ?? { label: client, color: "var(--color-text-secondary)", bg: "var(--color-surface-secondary)", border: "var(--color-border)" };

  // Data-driven: per-client theme-token colors come from CLIENT_CONFIG (varies
  // by client prop), so they stay inline rather than as static CSS.
  const colors = { color: resolved.color, backgroundColor: resolved.bg };

  if (onClick) {
    return (
      <button
        type="button"
        className={`${styles.badge} ${styles.button}`}
        onClick={(e) => { e.stopPropagation(); onClick(client); }}
        // eslint-disable-next-line react/forbid-dom-props -- data-driven per-client colors from CLIENT_CONFIG
        style={colors}
      >
        {resolved.label}
      </button>
    );
  }

  return (
    // eslint-disable-next-line react/forbid-dom-props -- data-driven per-client colors from CLIENT_CONFIG
    <span className={`${styles.badge} ${styles.span}`} style={colors}>
      {resolved.label}
    </span>
  );
}
